export function formatGroupList(list, parentId) {
  if (list.length) {
    const newList = list.filter((i) => i.parent_id !== parentId)
    const arr = list
      .filter((item) => item.parent_id === parentId)
      .map((item) => ({
        name: item.name,
        value: item.id,
        parent_id: item.parent_id,
        role: item.role,
        children: formatGroupList(newList, item.id) || [],
        cannotSelected: item.cannotSelected, // 接待界面判断是需要请求该分组下的快捷短语
      }))
    return arr
  } else {
    return []
  }
}

// 查找上层所有父级value并返回数组 (Cascader组件赋值用)
export const findParentValues = (nestedArray, targetValue) => {
  let result = []

  function search(node, path) {
    if (!node || !node?.children) return

    for (let child of node?.children) {
      const newPath = [...path, node?.value]
      if (child?.value === targetValue) {
        result.push(newPath)
      } else {
        search(child, newPath)
      }
    }
  }

  for (let node of nestedArray) {
    search(node, [])
  }

  const list = result?.flat()?.filter((value, index, self) => self?.indexOf(value) === index)
  list.push(targetValue)
  return list
}
